import { ChevronRight } from "lucide-react";
import { Fragment, type ReactNode } from "react";

export interface BreadcrumbItem {
  label: ReactNode;
  /** Click handler to override default link behaviour (e.g. setFocus). */
  onClick?: () => void;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav className="breadcrumb" aria-label="breadcrumb">
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <Fragment key={i}>
            {i > 0 && (
              <ChevronRight
                size={12}
                className="breadcrumb__sep"
                aria-hidden="true"
              />
            )}
            {isLast || !item.onClick ? (
              <span className={isLast ? "breadcrumb__current" : "breadcrumb__item"}>
                {item.label}
              </span>
            ) : (
              <button
                type="button"
                className="breadcrumb__item breadcrumb__link"
                onClick={item.onClick}
              >
                {item.label}
              </button>
            )}
          </Fragment>
        );
      })}
    </nav>
  );
}
